export default "__VITE_ASSET__b41c26f8__"